import { useCallback } from "react";
import { createContext, useContext, useState } from "react";
import ChannelsService from '../../../services/ChannelsService';
import DataStoreService from '../../../services/DataStore';
import { useSelector } from "react-redux";
import { findOptions } from "../../../helpers/StringHelper";
import { accessbilityOptions, deliveryOptions, historyOptions, licensingOptions, streamOptions } from "../../DataStore/components/Settings/config";

const getCompanyLogo = (user) => {
  const _arr = Array.isArray(user?.logo) ? user?.logo : (
    user?.logo?.fileList && Array.isArray(user?.logo?.fileList) ?
      user?.logo?.fileList.map(v => v.response ? v.response : v) : []);
  return Array.isArray(_arr) && _arr[0] ? _arr[0].url : null;
}

export const useInformationChannelContext = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.authentication);

  const fetchChannels = useCallback(async (id, changeLoading) => {
    if (changeLoading) {
      setLoading(true);
    }

    try {
      const { data } = await ChannelsService.getChannel(id);
      const { data: _dataFormLocation } = await DataStoreService.getForm('location');
      const { data: _dataFormStakeholder } = await DataStoreService.getForm('stakeholder');
      const users = [data.inbound, data.outbound];
      const _user = users.find((u) => u.id === user.company.id);
      const partner = users.find((u) => u.id !== user.company.id) || _user;
      const _dataForm = {
        locations: _dataFormLocation.store,
        entities: _dataFormStakeholder.store,
      };

      const _data = {
        id,
        dataSettings: {
          accessibility: findOptions(data.accessibility, accessbilityOptions),
          availabilityHistory: findOptions(data.history, historyOptions),
          availabilityStream: findOptions(data.stream, streamOptions),
          delivery: findOptions(data.delivery || 'custom', deliveryOptions),
          licensing: findOptions(data.licensing, licensingOptions),
        },
        subjects: data.subjects,
        dataChain: {
          source: data.outbound ? {
            name: data.outbound.name,
            datastakeId: data.outbound.userId,
            id: 'source',
            image: getCompanyLogo(data.outbound) || '/assets/images/info-channels/investor.svg',
          } : undefined,
          investor: data.inbound ? {
            name: data.inbound.name || '',
            id: 'investor',
            datastakeId: data.inbound.userId,
            image: getCompanyLogo(data.inbound) || '/assets/images/info-channels/investor.svg',
          } : undefined,
          subjects: [],
        },
        partner: partner || _user,
        form: _dataForm,
      };

      setData(_data);
    } catch (err) {
      console.log(err);
    }

    if (changeLoading) {
      setLoading(false);
    }
  }, [user]);

  return {
    data,
    loading,
    fetchChannels,
  };
}

export const InformationChannelContext = createContext({
  data: {},
  loading: false,
  fetchChannels: () => { },
});

export const InformationChannelProvider = ({ children }) => {
  const value = useInformationChannelContext();

  return (
    <InformationChannelContext.Provider value={value}>
      {children}
    </InformationChannelContext.Provider>
  );
}

export default function useInformationChannel() {
  const value = useContext(InformationChannelContext);
  return value;
}
